import React from "react";

function TreeView({ node }) {
  if (!node) return null;

  return (
    <ul className="ml-4 border-l pl-2">
      <li>
        <details open>
          <summary className="cursor-pointer font-semibold">{node.name}</summary>

          {/* show files */}
          {node.files && node.files.length > 0 && (
            <ul className="ml-4 list-disc text-sm">
              {node.files.map((file, index) => (
                <li key={index} className="text-gray-700">
                  <span style={{ color: file.policies > 0 ? 'green' : 'black' }}>
                    
  <span role="img" aria-label="file">📄</span> {file.name} <b style={{ backgroundColor: 'yellow' }}>({file.policies})</b>
</span>
                    
                </li>
              ))}
            </ul>
          )}

          {/* show subfolders */}
          {node.subFolders && node.subFolders.length > 0 && (
            <ul>
              {node.subFolders.map((sub, index) => (
                <li key={index}>
                  <TreeView node={sub} />
                </li>
              ))}
            </ul>
          )}
        </details>
      </li>
    </ul>
  );
}

export default TreeView;
